import Marquee from "react-fast-marquee";

const Item = ({ outline }) => (
  <span className="mx-8 flex items-center gap-8">
    <span
      className={
        "font-display text-6xl uppercase tracking-tight md:text-8xl " +
        (outline ? "text-outline" : "text-brand-bone")
      }
    >
      A world where local means instant
    </span>
    <span className="h-3 w-3 rounded-full bg-brand-volt" />
  </span>
);

export const EditorialMarquee = () => {
  return (
    <section
      data-testid="marquee-section"
      className="border-y border-brand-line py-10 md:py-14"
      aria-label="A world where local means instant"
    >
      <Marquee speed={55} gradient={false} autoFill>
        <Item outline={false} />
        <Item outline />
      </Marquee>
    </section>
  );
};
